import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { formatDate, FORMAT_DATE_BACK, postSubmit, getPreviousDate } from "@ui-seeker/utils"

import { commonFiltersValue, isLoadingCommonFilters, isSystemBusy } from "@signals"
import { DATE_PERIODS,GROUPED_BY } from "@constants"
import { marketAnalyzerEvolutionOffersFilters, marketAnalyzerIsEmpty, marketAnalyzerCurrentPeriod, marketAnalyzerEndDate } from "Pages/Pricing/MarketAnalyzer/@signals"
import { useMarketAnalyzerRoleConfig } from "Pages/Pricing/MarketAnalyzer/@hooks"


export default function useMarketAnalyzerShareMblData() {
	const { urlApiChart } = useMarketAnalyzerRoleConfig()

	const dataChart = useSignal([])
	const color = useSignal({})
	const series = useSignal([])
	const isLoading = useSignal(false)
	const selectedGroupedBy = useSignal(GROUPED_BY.GENERAL)

    const newFilters = commonFiltersValue.peek()

    useEffect(() => {
		if (isLoadingCommonFilters.value) batch(() => {
			isLoading.value = true
			dataChart.value = []
			marketAnalyzerIsEmpty.value = false
			postSubmit(`${urlApiChart}/share-mbl`, { ...commonFiltersValue.value, groupedBy: selectedGroupedBy.value }).then(res => {
				const [firstElement] = res.data
				if (!firstElement?.actualData?.length){
					dataChart.value = []
					marketAnalyzerIsEmpty.value = true
				} else {
					dataChart.value = res.data
					marketAnalyzerIsEmpty.value = false
				}
				
				color.value = res.color
				series.value = res.series
			}).catch(() =>
				isSystemBusy.value = true
			).finally(() => {
				isLoading.value = false
				isLoadingCommonFilters.value = false
			})
		})
	}, [isLoadingCommonFilters.value])

	const handleSelectedGroupedBy = (e) => {
		selectedGroupedBy.value = e.target.value
		isLoading.value = true
		dataChart.value = []
		postSubmit(`${urlApiChart}/share-mbl`, { ...commonFiltersValue.value, groupedBy: selectedGroupedBy.value }).then(res => {
			if (!res.data?.length)
				dataChart.value = []
			else
				dataChart.value = res.data
			
			color.value = res.color
			series.value = res.series
		}).catch(() => isSystemBusy.value = true
		).finally(() => {
			isLoading.value = false
		})
	}

	const handleClickShowEvolution = (groupedID = 0) => { batch(() => {
		marketAnalyzerEndDate.value = newFilters.endDate
		let startDate = formatDate(getPreviousDate({days: 6}, marketAnalyzerEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        marketAnalyzerCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        marketAnalyzerEvolutionOffersFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: marketAnalyzerEndDate.value,
			groupedBy: groupedID !== 0 ? selectedGroupedBy.value : GROUPED_BY.GENERAL,
			groupedID: groupedID
        }})
    }

	return {
		dataChart: dataChart.value,
		color: color.value,
		series: series.value,
		isLoading: isLoading.value,
		selectedGroupedBy: selectedGroupedBy.value,
		
		handleSelectedGroupedBy,
		handleClickShowEvolution
	}
}